import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class TimezoneInterceptor implements HttpInterceptor {
  private isISODateString(value: string): boolean {
    const isoDatePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;
    return typeof value === 'string' && isoDatePattern.test(value);
  }

  private convertToLocalDate(value: string): Date {
    // Simply parse the ISO string - JavaScript Date handles UTC conversion automatically
    // This creates a Date object that represents the same instant in time
    return new Date(value);
  }

  private processDateValues(body: any): any {
    if (!body) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {
      const value = body[key];

      if (this.isISODateString(value)) {
        // Keep the date as ISO string to avoid timezone conversion issues
        // The datepicker and date pipes will handle display formatting
        // This prevents the date from shifting on each save/update cycle
        body[key] = value;
      } else if (Array.isArray(value)) {
        body[key] = value.map(item => this.processDateValues(item));
      } else if (typeof value === 'object') {
        body[key] = this.processDateValues(value);
      }
    }

    return body;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          const clonedResponse = event.clone({
            body: this.processDateValues(event.body)
          });
          return clonedResponse;
        }
        return event;
      })
    );
  }
}

